import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore, useAlertStore, useSessionStore, useConfigStore } from '@lib/pp-shop-lib/stores';
import { Home, Checkout, CheckoutStart, ActivateOrder, Blank } from '@/views';
import { ResetPassword } from '@/views/account';
import accountRoutes from './account.routes';
import { logger } from '@lib/pp-shop-lib/helpers';

const routesLocal = window.routesLocal || [];

export const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    linkActiveClass: 'active',
    routes: [
        { path: '/shop/home', redirect: '/shop' },
        { path: '/shop', component: Home },
        { path: '/shop/cart', component: CheckoutStart },
        { path: '/shop/checkout', component: Checkout },
        { path: '/shop/activateorder', component: ActivateOrder },
        { path: '/shop/resetpwd', component: ResetPassword },
        { path: '/shop/setpwd', component: ResetPassword, meta: { showNewCustomerWelcome: true } },
        { ...accountRoutes },
        { path: '/:pathMatch(.*)*', component: Blank }
    ]
});

logger.debug(import.meta.env.BASE_URL)
router.beforeEach(async (to) => {
    // Handle baseRedirect for root path
    if (to.path === '/' && to.path !== to.redirectedFrom) {
        const configStore = useConfigStore();
        if (configStore.baseRedirect) {
            return configStore.baseRedirect;
        }
    }

    // clear alert on route change
    const alertStore = useAlertStore();
    alertStore.clear();

    const sessionStore = useSessionStore();
    sessionStore.set("route",to.path) 

    if (routesLocal[to.path]) {
       let localRoute = routesLocal[to.path];
       if (localRoute[0] != "/") localRoute = "/" + localRoute;
       document.location.href = document.location.origin + localRoute;
    }

    // Beim Logoutpath abmelden und auf gleicher eite bleiben
    if (to.path.split("/").pop() == "logout") {
        const authStore = useAuthStore();
        await authStore.logout()
        return '/shop/account/login'
    }

    if (to.matched.some((record) => record.meta?.requiresAuth)) {
        const authStore = useAuthStore();
        const isLoggedIn = Boolean(authStore.user?.token || authStore.user?.kid)
        if (!isLoggedIn) {
            authStore.returnUrl = to.fullPath
            return '/shop/account/login'
        }
    }
});
